import {
  CONTACT_FORM_RESET,
  CONTACT_STYLIST_FAILURE,
  CONTACT_STYLIST_REQUEST,
  CONTACT_STYLIST_SUCCESS,
} from '../actions/ActionTypes';

const initialState = {
  loading: false,
  error: null,
  last_action: null,
};

export default function stylist(state = initialState, action) {
  switch (action.type) {
    case CONTACT_STYLIST_REQUEST:
      return { ...state, loading: true, error: false, last_action: null };
    case CONTACT_STYLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        last_action: 'contact_success',
      };
    case CONTACT_STYLIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        last_action: 'contact_error',
      };
    case CONTACT_FORM_RESET:
      return {
        ...state,
        last_action: null,
      };
    default:
      return state;
  }
}
